module.exports = __webpack_public_path__ + "b7861b5bec21ef1951bcb57940c5030e.MP3";